import { encryptPayload } from "@/utils/cryptoUtils";
import { getPublicKey } from "@/api/request-encoding/getPublicKey";

export async function loginUser({ mobile_number, password }) {
  try {
    const publicKeyPem = await getPublicKey();
    const payload = await encryptPayload({ mobile_number, password }, publicKeyPem);

    const res = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/app/v1/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.detail || "Login failed");

    return data;
  } catch (err) {
    console.error("Login error:", err);
    throw err;
  }
}